<template>
    <div class="container">
        <div class="course-list">
            <div class="moco-course-list">
                <div class="clearfix">
                    <div v-for="item in showlist"
                         class='course-card-container'>
                        <a class='course-card'
                           @click="goclass(item._id)"
                           data-track="sztj-1-1">

                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span><em> {{item.gzcxjg |
                                        format}} </em>
                                    </div>
                                    <div class='course-card-price'><span>复审/换证</span><em> {{item.gzfsjg |
                                        format}}</em>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="page">
                    <el-pagination
                            background
                            layout="prev, pager, next,total"
                            prev-text="上一页"
                            next-text="下一页"
                            :total="total"
                            :page-size="limit"
                            @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Allcount from "./allcount";

    export default {
        components: {Allcount},
        name: "courseproduct",
        props: ['showworks'],
        data() {
            return {
                total: 0,
                page: 5,
                limit: 30,
                showlist: [],
            }
        },
        methods: {
            goclass(data) {
                this.$router.push({
                    name: 'Class',
                    params: {
                        id: data
                    }
                })
            },
            handleSearch() {
                this.page = 1;
                this.search();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.search();
            },
            search() {
                //计算总页数
                this.total = this.showworks.length;

                var limit = this.limit;
                var page = this.page;
                var worksdata = this.showworks.filter(function (u, index) {
                        return (index < limit * page && index >= limit * (page - 1))
                    }
                );
                this.showlist = worksdata;
            },
        },
        watch: {
            showworks(val, oldVal) {
                this.handleSearch();
            },
        },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            },
        }
    }
</script>

<style>
    /* xia */
    .container {
        width: 1386px;
        margin: 26px auto;
    }

    .course-list {
        padding: 10px 0 20px;
    }
    .moco-course-list {
        margin: 0 0 0 -18px;
    }
    .course-card-container {
        float: left;
        margin: 0 0 18px 18px;
        height: 256px;
        z-index: 0;
    }

    .course-card-container {
        width: 216px;
        position: relative;
        transition: .3s all linear;
    }
    .page {
        margin: 25px 0 auto;
        overflow: hidden;
        clear: both;
        text-align: center;
    }
</style>